<pos-app-spinner [show]="loading"></pos-app-spinner>
<div>
  <div class="modal-body">
    <div class="row">
      <div class="col-2 pt-2">
        <div><label>Current salesperson:</label></div>
      </div>
      <div class="col-3 pt-2 mx-2">{{ currentSalesPerson ?? 'Not Assigned' }}</div>
      <div class="col-2 pt-2"><label>New salesperson:</label></div>
      <div class="col-3 pt-2 mx-2">
        <ng-select placeholder="Select Salesperson" (change)="handleSelectedUser($event)" [clearable]="false" style="width: 100%">
          <ng-option *ngFor="let salesperson of salesPeopleList" [value]="salesperson">
            {{ salesperson.name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-flex float-end justify-content-end">
      <button class="btn btn-cancel float-right" (click)="handleCloseModel()">CANCEL</button>
      <button class="btn btn-save float-right" (click)="updateSalsePerson()" [disabled]="!formValid">
        {{ isClickAndCollect ? 'ACKNOWLEDGE' : 'UPDATE' }}
      </button>
    </div>
  </div>
</div>
